<nav class="relative w-full bg-slate-800 text-slate-100 border-b border-white/10 py-3" style="z-index: 100">
    <div class="mx-auto w-full max-w-[1320px] px-3">
        <div class="flex items-center justify-between gap-3">
            <a class="flex shrink-0 items-center" (click)="goTo('/shop/products')">
                <img
                    [src]="company.logoUrl && company.logoUrl !== '' ? company.logoUrl : 'assets/profilePic.png'"
                    alt="logo"
                    class="h-[75px] w-[75px] object-contain">
            </a>

            <button
                class="inline-flex items-center justify-center rounded-lg border-0 bg-transparent p-2 text-slate-200 hover:bg-white/10 lg:hidden"
                type="button"
                (click)="mobileMenuOpen = !mobileMenuOpen"
                [attr.aria-expanded]="mobileMenuOpen"
                aria-label="Apri menu">
                <svg *ngIf="!mobileMenuOpen" class="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>
                </svg>
                <svg *ngIf="mobileMenuOpen" class="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                </svg>
            </button>

            <ul class="mb-0 hidden flex-1 list-none items-center justify-between pl-0 lg:flex">
                <li>
                    <a class="nav-link" [ngClass]="{'active': activeMenu === 0}" aria-current="page" [routerLink]="['/shop']" (click)="setActiveMenu(0)">
                        Shop
                    </a>
                </li>
                <li *ngIf="isWellDoneUser">
                    <a class="nav-link" [ngClass]="{'active': activeMenu === 1}" aria-current="page" [routerLink]="[dashboardUrl]" (click)="setActiveMenu(1)">Home</a>
                </li>
                <li class="relative ml-auto">
                    <a class="nav-link relative" [ngClass]="{'active': activeMenu === 2}" [routerLink]="['/shop/cart']" (click)="setActiveMenu(2)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="icon" viewBox="0 0 20 20">
                            <path d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5zM3.102 4l1.313 7h8.17l1.313-7H3.102zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
                        </svg>
                        <span class="quantity-badge" *ngIf="getCartQuantity()>0" #cartBadge>{{ getCartQuantity() }}</span>
                    </a>
                </li>
            </ul>
        </div>

        <ul *ngIf="mobileMenuOpen" class="mb-0 mt-3 flex list-none flex-col gap-1 pl-0 lg:hidden">
            <li>
                <a class="nav-link" [ngClass]="{'active': activeMenu === 0}" [routerLink]="['/shop']" (click)="setActiveMenu(0); mobileMenuOpen = false">
                    Shop
                </a>
            </li>
            <li *ngIf="isWellDoneUser">
                <a class="nav-link" [ngClass]="{'active': activeMenu === 1}" [routerLink]="[dashboardUrl]" (click)="setActiveMenu(1); mobileMenuOpen = false">Home</a>
            </li>
            <li>
                <a class="nav-link relative inline-flex items-center" [ngClass]="{'active': activeMenu === 2}" [routerLink]="['/shop/cart']" (click)="setActiveMenu(2); mobileMenuOpen = false">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="icon" viewBox="0 0 20 20">
                        <path d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5zM3.102 4l1.313 7h8.17l1.313-7H3.102zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
                    </svg>
                    <span class="quantity-badge" *ngIf="getCartQuantity()>0">{{ getCartQuantity() }}</span>
                    <span class="ml-2">Carrello</span>
                </a>
            </li>
        </ul>
    </div>
</nav>
